import { all } from 'redux-saga/effects';
import adminSaga from './Admin/adminSaga';
import customerSaga from './Customer/customerSaga';

import peopleSaga from './People/peopleSaga';
import profileSaga from './Profile/profileSaga';
import subscriptionSaga from './Subscription/subscriptionSaga';
import supportSaga from './Support/supportSaga';

import collabSaga from './Collab/collabSaga';
import registerSaga from './Registration/registerSaga';

export default function* rootSaga() {
  yield all([
    supportSaga(),
    profileSaga(),
    subscriptionSaga(),
    adminSaga(),
    customerSaga(),
    peopleSaga(),
    collabSaga(),
    registerSaga(),
  ]);
}
